const pisWorkspaces = {
  bindings: {
    onPisLock: '&',
    onWorkspaceSelect: '&',
    pisLockStatus: '<',
    hasLock: '<',
  },
  templateUrl: '/modules/pis-tool/workspaces/pis-workspaces.html',
  controller: 'PisWorkspacesController',
};

angular
  .module('pis-tool.module')
  .component('pisWorkspaces', pisWorkspaces)
  .config(function($stateProvider) {
    $stateProvider.state('pis.workspaces', {
      url: '/workspaces',
      views: {
        'pisview@pis': 'pisWorkspaces',
      },
      resolve: {
        // workspaces: PISService => PISService.getAllWorkspaces(),
      },
    });
  });
